import {useMemo} from "react";
import {Desk} from "../../../api/Model";
import {RemoteValue} from "../../../util/RemoteValue";
import {useCreateAndOpenSeatingPlan, useUnassignDesks} from "../useFixDeskAssignments";
import {Typography} from "@mui/material";
import {useConfirm} from "material-ui-confirm";

export function useFixDesksAssignedToNonResidents(problems: RemoteValue<{desk: Desk}[]>) {
    const confirm = useConfirm();
    const createAndOpenSeatingPlan = useCreateAndOpenSeatingPlan();
    const unassignDesks = useUnassignDesks();

    return useMemo(() => createAndOpenSeatingPlan && (async () => {
        const {confirmed} = await confirm({
            title: 'Create a fixing seating plan?',
            description: (
                <Typography>
                    After you create the seating plan unassigning desks from non-residents,
                    you will be able to <b>review and correct</b> the proposed changes
                    and <b>apply the seating plan</b> once you are satisfied with the changes.
                </Typography>
            ),
            confirmationText: 'Create seating plan',
            confirmationButtonProps: {variant: 'contained'},
        });
        if (!confirmed) return;

        await createAndOpenSeatingPlan(
            {
                name: 'Unassign desks from non-residents',
                description: 'Proposed fixes for desks assigned to non-residents.',
            },
            async seatingPlan => unassignDesks(seatingPlan, (await problems.value).map(problem => problem.desk)),
        );
    }), [confirm, createAndOpenSeatingPlan]);
}
